import Excel from 'exceljs';

export default async (title, fileName, columns, rows) => {
  const today = new Date();
  const workbook = new Excel.Workbook({
    created: today,
    modified: today,
    lastPrinted: today,
  });

  const worksheet = workbook.addWorksheet(title);

  worksheet.views = [
    { state: 'frozen', ySplit: 1 },
  ];

  worksheet.columns = columns;
  worksheet.addRows(rows);

  const style = 'thin';
  worksheet.eachRow((row) => {
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.alignment = {
        wrapText: true,
      };
      cell.border = {
        top: { style },
        left: { style },
        bottom: { style },
        right: { style },
      };
    });
  });

  const bufferData = await workbook.xlsx.writeBuffer();
  const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([bufferData], { type });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.download = `${fileName}_${today.getTime()}.xlsx`;
  anchor.click();
  window.URL.revokeObjectURL(url);
};
